<template>
  <div>
    <div style="display: table; width: 1000px;margin: 0 auto; margin: 15px auto; ">
      <div
        style="display: table-cell; text-align: left; font-size: 20px;padding-right: 30px;">ヒロソフィー納品書</div>
      <div style="display: table-cell;width: 70%; text-align: left; font-size: 20px;">店舗名：{{ adminSession.orderAcceptSelectedStoreName }}</div>
    </div>

    <div style="display: table; width: 1000px;margin: 0 auto; margin: 15px auto; ">
      <div style="display: table-cell;width: 50%; text-align: right; font-size: 20px; ">
        <span style="width: 50px;padding-right: 30px;">{{ printMonth }}&nbsp;月</span>
        <span style="width: 50px;padding-right: 35px;">{{ printDate }}&nbsp;日</span>
        <span style="width: 50px;">出荷</span>
      </div>
    </div>

    <div style="display: table; width: 1000px;margin: 0 auto; margin: 15px auto; ">
      <div style="display: table-cell;width: 50%; text-align: right; font-size: 20px; ">
        <span style="width: 50px;padding-right: 5px;">納品希望日：</span>
        <span style="width: 50px;padding-right: 30px;">{{ requestedShippingMonth }}&nbsp;月</span>
        <span style="width: 50px;">{{ requestedShippingDate }}&nbsp;日</span>
      </div>
    </div>

    <div style="display: table; width: 1000px;margin: 0 auto; margin: 15px auto; ">
      <div style="display: table-cell;width: 50%; text-align: right; font-size: 20px;">
        <span style="width: 50px;padding-right: 10px;">出荷元：</span>
        <span style="width: 50px;padding-right: 170px; border-bottom-style: ridge;">
          <!--납품서 출력버튼에 공장 선택하도록 해서 이 화면에 출하공장을 표시 하고 QR에도 등록-->
          <!-- {{ user.userGroup }} -->
          千葉工場
        </span>
      </div>
    </div>

    <div style=" margin: 0 auto; width: 1000px; font-size: 16px;">
      <div>
        <table style="width: 1000px;">
          <tr style="height: 50px; background-color: #ffffff;">
            <td>JANコード</td>
            <td>商品名</td>
            <td style="background-color: rgb(201, 213, 255);">三田</td>
            <td>千葉</td>
            <td style="border-bottom: none;"></td>
            <td>JANコード</td>
            <td>商品名</td>
            <td style="background-color: rgb(201, 213, 255);">三田</td>
            <td>千葉</td>
          </tr>

          <tr v-for="orderDetail in orderDetails" style="height: 50px; background-color: #ffffff;"><!--white-->
            <!-- <td
              style="width: 130px; text-align: left; padding-left: 5px;"
              v-bind:class="{ chiba: orderDetail.isGray }"
            >{{ orderDetail.janCode }}</td> -->
            <td
              style="width: 130px; text-align: left; padding-left: 5px;"
            >{{ orderDetail.janCode }}</td>
            <td
              style="width: 220px; text-align: left; padding-left: 5px;"
            >{{ orderDetail.itemName }}</td>
            <td
              style="width: 50px; background-color: rgb(201, 213, 255)"
            >{{ orderDetail.region1 }}</td>
            <td style="width: 50px;">{{ orderDetail.region2 }}</td>
            <td style="width: 50px; border: none;">
              <!-- {{ orderDetail.region1 + orderDetail.region2 }} -->
            </td>
            <td
              style="width: 130px; text-align: left; padding-left: 5px;"
            >{{ orderDetail.janCode2 }}</td>
            <td
              style="width: 220px; text-align: left; padding-left: 5px;"
            >{{ orderDetail.itemName2 }}</td>
            <td
              style="width: 50px; background-color: rgb(201, 213, 255)"
            >{{ orderDetail.region21 }}</td>
            <td style="width: 50px;">{{ orderDetail.region22 }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div style="display: table; width: 1000px; margin: 15px auto; border: 1px solid #000000;">
      <p style="font-size: 16px;margin: 0 auto; padding: 10px 10px 0px 10px; text-align:left; ">
        <B>備考</B>
      </p>
      <p
        style="font-size: 14px;margin: 0 auto; padding: 0px 10px; text-align:left; white-space:pre-wrap; word-wrap:break-word;"
      >{{ remarks }}</p>
    </div>

    <!-- QRCode 20240326 kium  -->
    <div style="display: table; width: 1000px; height:auto; margin: 15px auto; border: 0px solid #000000;">
      <p style="font-size: 16px;margin: 0 auto; padding: 10px 10px 0px 10px; text-align:left; ">
        <qr-code 
          :text = "orderDetailsQRCode"
          error-level="L">
        </qr-code>
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import moment from 'moment-timezone'

export default {
  created() {
    console.log('deliveryslip')

    let thisObj = this
    this.storeCode = window.sessionStorage.getItem('storeCode')
    window.sessionStorage.removeItem('storeCode')

    this.warehouseId = window.sessionStorage.getItem('warehouseId')
    window.sessionStorage.removeItem('warehouseId')
    
    this.storeName = this.adminSession.orderAcceptSelectedStoreName
    this.orderManagementId = this.adminSession.orderAcceptOrderManagementId
    let sendRequest = {
      orderManagementId: this.orderManagementId
    }

    ServerApiCallService.deliveryslip(sendRequest)
      .then(response => {

        // 수량이 0인 상품은 제외 20240114 kium
        let orderDetails = [];
        for (let i=0; i<response.data.orderDetails.length; i++) {
          let row = response.data.orderDetails[i];

          // 치바쪽 수량체크     
          if (row.region2 > 0) {
            orderDetails.push(row);
          }
        }

        let size = orderDetails.length
        let rowSize = parseInt((size + 1) / 2)
        let orderIndex = 0
        let isGray = true
        let categoryNameCache = ''

        // 表示順
        orderDetails.sort(function(a, b) {
          if (a.itemName > b.itemName) return 1
          if (a.itemName < b.itemName) return -1
          // a must be equal to b
          return 0
        })
        orderDetails.sort(function(a, b) {
          if (a.itemCategoryId > b.itemCategoryId) return 1
          if (a.itemCategoryId < b.itemCategoryId) return -1
          // a must be equal to b
          return 0
        })
        
        for (let i=0; i<orderDetails.length; i++) {
          let row = orderDetails[i];

          // 라인에 색깔을 칠하는걸 없앤다 20240419 kium
          // if (categoryNameCache !== row.itemCategoryName) {
          //   isGray = !isGray;
          //   categoryNameCache = row.itemCategoryName;
          // }
          // row.isGray = isGray;

          if (orderIndex < rowSize) {
            thisObj.orderDetailsLeft.push(row);
          } else {
            thisObj.orderDetailsRight.push(row);
          }

          orderIndex++;
        }
        
        // Jan코드로 QRCode데이타 작성 20240326 kium
        let strQrCode = '';
        let strJanCode = '';
        strQrCode = this.warehouseId + '^' + this.storeCode + '^' + orderDetails[0].shippingDate + '^' + this.orderManagementId + "|"
        
        for (let i = 0; i < orderDetails.length; i++) {
          // TAG의 jan이 6자리이기에 13자리에서 6자리로 변형
          let substr = orderDetails[i].janCode.toString()
          // let Jan6Digits= substr.substring(7)

          // QRCodeデータ
          if (i != orderDetails.length -1) {
            strJanCode += substr + '^' + (orderDetails[i].region2).toString() + "|"
          } else {
            strJanCode += substr + '^' + (orderDetails[i].region2).toString()
          }
        }
        thisObj.orderDetailsQRCode = strQrCode + strJanCode ;

        for (let i = 0; i < rowSize; i++) {
          let orderDetail = {
            janCode: thisObj.orderDetailsLeft[i].janCode,
            itemName: thisObj.orderDetailsLeft[i].itemName,
            region1: thisObj.orderDetailsLeft[i].region1,
            region2: thisObj.orderDetailsLeft[i].region2,
            isGray: thisObj.orderDetailsLeft[i].isGray
          }

          if (i < thisObj.orderDetailsRight.length) {
            orderDetail.janCode2 = thisObj.orderDetailsRight[i].janCode
            orderDetail.itemName2 = thisObj.orderDetailsRight[i].itemName
            orderDetail.region21 = thisObj.orderDetailsRight[i].region1
            orderDetail.region22 = thisObj.orderDetailsRight[i].region2
            orderDetail.isGray2 = thisObj.orderDetailsRight[i].isGray
          }
          
          thisObj.orderDetails.push(orderDetail)
        }

        // 점포 도착일
        if ( orderDetails !== 'undefined' && orderDetails.length > 0 ) {
          this.requestedShippingMonth = orderDetails[0].shippingDate.substring(4, 6)
          this.requestedShippingDate = orderDetails[0].shippingDate.substring(6, 8)
          this.remarks = orderDetails[0].remarks
        }
      })
      .catch(error => {
        console.log("error: ", error);
        console.log('There was an error:', error.response)
      })
  },
  computed: {
    ...mapState({
      user: state => state.user,
      adminSession: state => state.adminSession
    })
  },
  methods: {},
  data() {
    return {
      storeCode:'',
      storeName:'',
      warehouseId:'',
      orderDetails: [],
      orderDetailsQRCode: '',
      orderDetailsLeft: [],
      orderDetailsRight: [],
      printMonth: moment(new Date()).format('MM'),
      printDate: moment(new Date()).format('DD'),
      requestedShippingMonth: '',
      requestedShippingDate: '',
      remarks: '',
      headers: [
        { text: this.$t('important'), value: 'isImportant', sortable: false },
        {
          text: this.$t('sales.table-header-registerDate'),
          value: 'createdAt',
          sortable: false
        },
        {
          text: this.$t('sales.table-header-contact'),
          value: 'notice',
          sortable: false
        }
      ]
    }
  }
}
</script>

<style scoped>
.chiba {
  background-color: silver;
}
table {
  margin: 0 auto;
  padding: 0px 0px;
  background-color: #000000;
  border-spacing: 0px;
  border-collapse: collapse;
}
td {
  border: 1px solid #000000;
}
..theme--light.application {
  background-color: #ffffff !important;
}
</style>
